export const DEFAULT_CHUNK_SIZE = 20;
